import { signal } from '@preact/signals-react';
import { get } from 'lodash';
import moment from 'moment';
import { ISettingBackgroundItem } from './types/appointment';
export const NAME_REDUCER = 'appointment';

export const PREFIX_ACTIONS = 'appointment_feature_';


export const PATH_LOADING = {
  getAppointments: `loading.${NAME_REDUCER}.getAppointments`,
  getTableAppointments: `loading.${NAME_REDUCER}.getTableAppointments`,
  getStaffs: `loading.${NAME_REDUCER}.getStaffs`,
  getLockBreakTimes: `loading.${NAME_REDUCER}.getLockBreakTimes`,
  initServices: `loading.${NAME_REDUCER}.initServices`,
  listStaffsOffLoading: `loading.${NAME_REDUCER}.listStaffsOffLoading`,
};

export const CALENDAR_DISTANCE_TIMELINE = {
  ONE_HOUR: 60,
  HAlF_HOUR: 30,
  QUARTER_HOUR: 15,
};

export enum CALENDAR_VIEW_TYPE {
  DAY_VIEW = 'DAY_VIEW',
  WEEK_VIEW = 'WEEK_VIEW',
  TWO_WEEKS = '2_WEEKS',
  MONTH_VIEW = 'MONTH_VIEW',
  YEAR_VIEW = 'YEAR_VIEW',
  YEAR_COMPARISON = 'YEAR_COMPARISON',
}

export enum STAFF_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
export enum STAFF_TYPE {
  ADMIN = 'ADMIN',
  OTHER = 'OTHER',
  TECHNICAL = 'TECHNICAL',
  CASHIER = 'CASHIER',
}

export enum APPOINTMENT_LAYOUT {
  CALENDAR = 'CALENDAR',
  LIST = 'LIST',
}

export enum CALENDAR_TIME_TYPE {
  BLOCK = 'BLOCK',
  BREAK = 'BREAK',
}

export enum CALENDAR_ITEM_TYPES {
  APPOINTMENT = 'APPOINTMENT',
  MULTI = 'MULTI',
  APPOINTMENT_CANCEL = 'APPOINTMENT_CANCEL',
  // APPOINTMENT_NO_SHOW = 'APPOINTMENT_NO_SHOW',
  BREAK_STAFF = 'BREAK_STAFF',
  BLOCK_HOURS = 'BLOCK_HOURS',
}

export const daysOfWeek = Array.from(Array(7).keys()).map((o) => {
  const day = moment().set('day', o + 1);
  return {
    label: day.format('dddd'),
    value: day.isoWeekday(),
  };
});

export enum APPOINTMENT_SOURCE_TYPE {
  ONLINE = 'ONLINE',
  POS = 'CALL_IN',
  APP = 'APP',
}

export const CALENDAR_TIME_SET = {
  open: moment().set({ hour: 8, minute: 0, second: 0 }),
  close: moment().set({ hour: 22, minute: 0, second: 0 }),
};

export enum PROLONGED_TIME_STATUS {
  ADD = 'ADD',
  MINUS = 'MINUS',
}

export enum APPOINTMENT_STATUS {
  NEW = 0,
  ON_HOLD = -1,
  CONFIRM = 1,
  CANCEL = 2,
  NO_SHOW = 3,
  DELETE = 4,
  CHECK_IN = 5,
  PAID = 6,
}

export const AllAppointmentStatus = [
  APPOINTMENT_STATUS.NEW,
  APPOINTMENT_STATUS.CONFIRM,
  APPOINTMENT_STATUS.NO_SHOW,
  APPOINTMENT_STATUS.CHECK_IN,
  APPOINTMENT_STATUS.PAID,
  APPOINTMENT_STATUS.ON_HOLD,
];
export const appointmentNoneEdit = [
  APPOINTMENT_STATUS.NO_SHOW,
  APPOINTMENT_STATUS.CANCEL,
  APPOINTMENT_STATUS.PAID,
  APPOINTMENT_STATUS.CHECK_IN,
];
export const appointmentShowRequestStaff = [
  APPOINTMENT_STATUS.NEW,
  APPOINTMENT_STATUS.CONFIRM,
  APPOINTMENT_STATUS.CHECK_IN,
];
export const appointmentStatusObject = {
  [APPOINTMENT_STATUS.NEW]: 'New',
  [APPOINTMENT_STATUS.CONFIRM]: 'Confirmed',
  [APPOINTMENT_STATUS.CHECK_IN]: 'Check In',
  [APPOINTMENT_STATUS.CANCEL]: 'Cancel',
  [APPOINTMENT_STATUS.NO_SHOW]: 'No show',
  [APPOINTMENT_STATUS.DELETE]: 'Delete',
};

export const NO_SHOW_CONFIG = signal({
  fill: '#F6F7F9',
  stroke: '#B1BBC8',
});
export const CANCEL_CONFIG = signal({
  fill: '#FFE5E7',
  stroke: '#F5767F',
});
export const CONFIRM_CONFIG = signal({
  fill: '#D1F9EB',
  stroke: '#0C865D',
});
export const CHECK_IN_CONFIG = signal({
  fill: '#D7EDFF',
  stroke: '#4B63C7',
});
export const NEW_CONFIG = signal({
  fill: '#E4F4F6',
  stroke: '#6FABB6',
});
export const ON_HOLD_CONFIG = signal({
  fill: '#FFE577',
  stroke: '#4B63C7',
});
export const MULTI_CONFIG = signal({
  stroke: '#8B33EA',
  fill: '#D5B4FE',
});
export const BREAK_STAFF_CONFIG = signal({
  stroke: '#EBA33B',
  fill: '#FDF4CE',
});
export const BLOCK_HOURS_CONFIG = signal({
  stroke: '#232F3E',
  fill: '#ADADAD',
});
export const GROUP_CONFIG = signal({
  stroke: '#4384FF',
  fill: '#4384FF',
});

export const defualtAppointmentColorSets: ISettingBackgroundItem[] = [
  {
    status: 'MULTI',
    color: '#8B33EA_#D5B4FE',
  },
  {
    status: APPOINTMENT_STATUS.NEW?.toString(),
    color: '#6FABB6_#E4F4F6',
  },
  {
    status: APPOINTMENT_STATUS.CONFIRM?.toString(),
    color: '#0C865D_#D1F9EB',
  },
  {
    status: APPOINTMENT_STATUS.CHECK_IN?.toString(),
    color: '#4B63C7_#D7EDFF',
  },
  {
    status: APPOINTMENT_STATUS.CANCEL?.toString(),
    color: '#F5767F_#FFE5E7',
  },
  {
    status: APPOINTMENT_STATUS.NO_SHOW?.toString(),
    color: '#B1BBC8_#F6F7F9',
  },
  {
    status: CALENDAR_ITEM_TYPES.BREAK_STAFF?.toString(),
    color: '#EBA33B_#FDF4CE',
  },
  {
    status: CALENDAR_ITEM_TYPES.BLOCK_HOURS?.toString(),
    color: '#232F3E_#ADADAD',
  },
  {
    status: 'GROUP',
    color: '#4384FF_#4384FF',
  },

];

export const fetched = signal(false);
export const listCalendarItemTypesSignal = [
  {
    label: 'Multiple',
    value: 'MULTI',
    stroke: MULTI_CONFIG.value.stroke,
    fill: MULTI_CONFIG.value.fill,
  },
  {
    label: 'Appointment',
    value: APPOINTMENT_STATUS.NEW,
    fill: NEW_CONFIG.value.fill,
    stroke: NEW_CONFIG.value.stroke,
  },
  {
    label: 'On hold',
    value: APPOINTMENT_STATUS.ON_HOLD,
    fill: ON_HOLD_CONFIG.value.fill,
    stroke: ON_HOLD_CONFIG.value.stroke,
  },
  {
    label: 'Confirm',
    value: APPOINTMENT_STATUS.CONFIRM,
    fill: CONFIRM_CONFIG.value.fill,
    stroke: CONFIRM_CONFIG.value.stroke,
  },
  {
    label: 'Check In',
    value: APPOINTMENT_STATUS.CHECK_IN,
    fill: CHECK_IN_CONFIG.value.fill,
    stroke: CHECK_IN_CONFIG.value.stroke,
  },
  {
    label: 'Cancel',
    value: APPOINTMENT_STATUS.CANCEL,
    fill: CANCEL_CONFIG.value.fill,
    stroke: CANCEL_CONFIG.value.stroke,
  },
  {
    label: 'No show',
    value: APPOINTMENT_STATUS.NO_SHOW,
    fill: NO_SHOW_CONFIG.value.fill,
    stroke: NO_SHOW_CONFIG.value.stroke,
  },
  {
    label: 'Staff Break',
    value: CALENDAR_ITEM_TYPES.BREAK_STAFF,
    fill: BREAK_STAFF_CONFIG.value.fill,
    stroke: BREAK_STAFF_CONFIG.value.stroke,
  },
  {
    label: 'Block Times',
    value: CALENDAR_ITEM_TYPES.BLOCK_HOURS,
    fill: BLOCK_HOURS_CONFIG.value.fill,
    stroke: BLOCK_HOURS_CONFIG.value.stroke,
  },
];

export const saveAppointmentColor = (
  id: string | APPOINTMENT_STATUS,
  fill: string,
  stroke: string
) => {
  switch (id?.toString()) {
    case CALENDAR_ITEM_TYPES.MULTI?.toString(): {
      MULTI_CONFIG.value = {
        fill,
        stroke,
      };
      break;
    }
    case CALENDAR_ITEM_TYPES.BREAK_STAFF?.toString():
      BREAK_STAFF_CONFIG.value = {
        fill,
        stroke,
      };
      break;
    case CALENDAR_ITEM_TYPES.BLOCK_HOURS?.toString():
      BLOCK_HOURS_CONFIG.value = {
        fill,
        stroke,
      };
      break;
    case APPOINTMENT_STATUS.NEW?.toString():
      NEW_CONFIG.value = {
        fill,
        stroke,
      };
      break;
    case APPOINTMENT_STATUS.ON_HOLD?.toString():
      ON_HOLD_CONFIG.value = {
        fill,
        stroke,
      };
      break;
    case APPOINTMENT_STATUS.CONFIRM?.toString():
      CONFIRM_CONFIG.value = {
        fill,
        stroke,
      };
      break;
    case APPOINTMENT_STATUS.CHECK_IN?.toString():
      CHECK_IN_CONFIG.value = {
        fill,
        stroke,
      };
      break;
    case APPOINTMENT_STATUS.CANCEL?.toString():
      CANCEL_CONFIG.value = {
        fill,
        stroke,
      };
      break;
    case APPOINTMENT_STATUS.NO_SHOW?.toString():
      NO_SHOW_CONFIG.value = {
        fill,
        stroke,
      };
      break;
    case 'GROUP':
      GROUP_CONFIG.value = {
        fill,
        stroke,
      };
      break;
  }
};

export const getAptStatusTheme = (status?: APPOINTMENT_STATUS) => {
  switch (status) {
    case APPOINTMENT_STATUS.NO_SHOW:
      return {
        fill: NO_SHOW_CONFIG.value.fill,
        stroke: NO_SHOW_CONFIG.value.stroke,
      };
    case APPOINTMENT_STATUS.DELETE:
    case APPOINTMENT_STATUS.CANCEL:
      return {
        fill: CANCEL_CONFIG.value.fill,
        stroke: CANCEL_CONFIG.value.stroke,
      };
    case APPOINTMENT_STATUS.CONFIRM:
      return {
        fill: CONFIRM_CONFIG.value.fill,
        stroke: CONFIRM_CONFIG.value.stroke,
      };
    case APPOINTMENT_STATUS.ON_HOLD:
      return {
        fill: ON_HOLD_CONFIG.value.fill,
        stroke: ON_HOLD_CONFIG.value.stroke,
      };
    case APPOINTMENT_STATUS.CHECK_IN:
    case APPOINTMENT_STATUS.PAID:
      return {
        fill: CHECK_IN_CONFIG.value.fill,
        stroke: CHECK_IN_CONFIG.value.stroke,
      };
    
    case APPOINTMENT_STATUS.NEW:
    default:
      return {
        fill: NEW_CONFIG.value.fill,
        stroke: NEW_CONFIG.value.stroke,
      };
  }
};

export const appointmentStatusItemTypes = AllAppointmentStatus.map((o) => {
  const theme = getAptStatusTheme(o);
  return {
    label:
      get(
        {
          [APPOINTMENT_STATUS.NEW]: 'Appointment',
          [APPOINTMENT_STATUS.CONFIRM]: 'Confirmed',
          [APPOINTMENT_STATUS.CANCEL]: 'Cancel',
          [APPOINTMENT_STATUS.NO_SHOW]: 'No show',
          [APPOINTMENT_STATUS.CHECK_IN]: 'Check In',
        },
        [o],
        ''
      ) || '',
    value: o,
    fill: theme.fill,
    stroke: theme.stroke,
  };
});

export const listAppointmentStatus = Object.entries(
  appointmentStatusObject
).map(([value, label]) => ({
  label,
  value,
}));

export const DEFAULT_STAFF_LIMIT_PAGING = 14;
export const DEFAULT_STAFF_LIMIT_PAGING_LEVEL_2 = 20;